import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { PlanComponentView } from '../PlanComponentView';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';

/**
 * プラン入力項目チェックモード
 */
export class PlanCheckMode extends WprBaseViewModeInfo<PlanComponentView>{
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Type: WprControlInfo = null;
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('planCheckMode');
	}
	// --------------------------------------------------------------------------
	
	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('活性');
		list.push('非活性');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('next', { 
			enabled: [
				{ mode: '非活性', value: false}, 
				{ mode: 'other', value: true},
			],
		});
		this.addControl('buttonName', {
			value: [
				{ mode: '非活性', value: 'プランを選択してください'},
				{ mode: 'other', value: 'このプランで次に進む'},
			]
		});
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if(this.m_Type.value === '')
			return '非活性';
		else
			return '活性';
	}
	// --------------------------------------------------------------------------
}